export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAILED = "AUTH_FAILED";
export const SET_SNACKBAR = "SET_SNACKBAR";